export default __webpack_public_path__ + "static/media/g4158.7aa179f7.svg";